// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 604 ? "51d29bd9" : chunkId) + "." + {"478":"e32f7d63ca577369","604":"2a94b9da125bebeb"}[chunkId] + ".js";
};